import React, { useState, useEffect } from "react";
import FooterBar from "./layout/FooterBar";

const Cassa = (props) => {
    const [carriers, setCarriers] = useState([]);
    
    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-4 col-md-5">
                    <div className="card">
                        <div className="card-body"></div>
                    </div>
                </div>
                <div className="col-lg-8 col-md-7">
                    <div className="card">
                        <div className="card-body"></div>
                    </div>
                </div>
            </div>
            <FooterBar
                footerTitle="Cassa"
                footerIcon="point_of_sale"
                footerLink="/cassa"
            />
        </div>
    );
};
export default Cassa;